<script>
import Circular from '../chart/Circular';

export default {
	name: 'DoughnutChart',

	mixins: [
		Circular,
	],

	computed: {
		chartOptions() {
			return {
				...this.circularOptions,
			};
		},
	},

	created() {
		this.chartId = 'doughnut';
		this.chartType = 'doughnut';
	},
};
</script>

<style lang="scss" scoped src="./doughnut-chart.scss" />
